<template>
  <div>
    <div class="popup-wrap popup-login only-register active">
      <div class="popup-box">
        <div class="logo">
          <img :src="$getThemeImagePath('stake-logo.png')" alt="">
        </div>
        <i class="content-left" />
        <div class="content">
          <div class="form-wrap login-form">
            <h4 class="register-title font-w-b text-align-L">
              <span class="highlight-dark-red">{{ $t("Bao.create_account") }}</span>{{ $t("Bao.create") }}
            </h4>
            <h5 class="register-subtitle">
              {{ $t("Bao.contact_info") }}
            </h5>
            <hr class="separator-line">
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('username') }">
              <label for="username">
                {{ $t("Bao.username") }}
              </label>

              <input
                v-model="postForm.username"
                v-validate="'required'"
                class="modal_register_ipt bg-white border-0"
                type="text"
                :placeholder="$t('Bao.member_username_limit')"
                name="username"
                :data-vv-as="$t('Bao.username')"
                autocomplete="off"
                @input="usercheck"
              >
              <div v-if="usernameError === $t('Bao.username_available')" class="account_good">
                {{ usernameError }}
              </div>
              <div v-else-if="usernameError" class="help-block">
                {{ usernameError }}
              </div>
              <div v-else-if="errors.has('username')" class="help-block">
                {{ $t("Bao.user_name_error") }}
              </div>
            </div>
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_pass') }">
              <label>
                {{ $t("Bao.password") }}
              </label>

              <input
                ref="newPassword"
                v-model="postForm.newPassword"
                v-validate="'required'"
                class="modal_register_ipt bg-white border-0"
                :placeholder=" $t('Bao.password_notice')"
                type="password"
                name="check_pass"
                :data-vv-as="$t('Bao.newPassword')"
                autocomplete="new-password"
                @input="pwdCheck"
              >
              <div v-if="pwdError" class="help-block">
                {{ pwdError }}
              </div>
              <div v-if="errors.has('newPassword')" class="help-block">
                {{ $t("Bao.new_password_error") }}
              </div>
            </div>
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_confirm_pass') }">
              <label for="passwordz">
                {{ $t("Bao.confirmPassword") }}
              </label>

              <input
                v-model="postForm.confirmPassword"
                v-validate="'required|confirmed:newPassword'"
                class="modal_register_ipt bg-white border-0"
                type="password"
                name="check_confirm_pass"
                :placeholder="$t('Bao.confirm_pass')"
                :data-vv-as="$t('Bao.confirmPassword')"
                autocomplete="off"
              >
              <div v-if="errors.has('check_confirm_pass')" class="help-block">
                {{ $t("Bao.confirm_password_error") }}
              </div>
            </div>
            <div v-if="$store.state.brand.permissionInfo.email_need_verify" class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_email') }">
              <label for="">
                {{ $t("Bao.e-mail") }}
              </label>
              <input
                v-model="postForm.email"
                v-validate="'required'"
                class="modal_register_ipt bg-white border-0"
                type="email"
                name="check_email"
                :placeholder="$t('Bao.e-mail')"
                autocomplete="off"
              >
              <div v-if="errors.has('check_email')" class="help-block">
                {{ $t("Bao.email_error") }}
              </div>
            </div>
            <div v-if="$store.state.brand.permissionInfo.register_need_phone" class="form-input-1 form-county-code-1" :class="{ 'form-input-error-1': errors.has('phone') }">
              <label for="">
                {{ $t("Bao.phone") }}
              </label>
              <div class="form-select-1" :class="{ 'active': isFlagShow }" @click="toggleFlagShow">
                <div class="form-select-value">
                  <img :src="$getThemeImagePath('japan.png')" alt="">
                </div>
              </div>
              <input
                v-model="postForm.phone"
                v-validate="'required'"
                type="text"
                name="phone"
                :data-vv-as="$t('Bao.phone')"
                :required="true"
                autocomplete="off"
                @input="phonecheck"
              >
              <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
                {{ phoneError }}
              </div>
              <div v-else-if="phoneError" class="help-block">
                {{ phoneError }}
              </div>
            </div>
            <!-- <script>
            $(function () {
            $(".form-select-value").click(function () {
            $(this).toggleClass("active");
            });
            });
          </script> -->
            <h5 class="register-subtitle">
              {{ $t("Bao.personal_info") }}
            </h5>
            <hr class="separator-line">
            <div class="form-input-1 form-dorp-down-1" :class="{ 'form-input-error-1': errors.has('check_roman_last') }">
              <label>
                {{ $t('Bao.romanization_of_last_name') }}
              </label>
              <input
                v-model="romanizationOfLastName"
                v-validate="'required'"
                type="text"
                name="check_roman_last"
                :data-vv-as="$t('Bao.romanization_of_last_name')"
                :required="true"
                autocomplete="off"
              >
              <div v-if="errors.has('check_roman_last')" class="help-block">
                {{ $t("Bao.romanization_of_last_name_error") }}
              </div>
            </div>
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_roman_first') }">
              <label>
                {{ $t('Bao.romanization_of_first_name') }}
              </label>
              <input
                v-model="romanizationOfFirstName"
                v-validate="'required'"
                type="text"
                name="check_roman_first"
                :data-vv-as="$t('Bao.romanization_of_first_name')"
                :required="true"
                autocomplete="off"
              >
              <div v-if="errors.has('check_roman_first')" class="help-block">
                {{ $t("Bao.romanization_of_first_name_error") }}
              </div>
            </div>
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_last') }">
              <label>
                {{ $t('Bao.last_name') }}
              </label>
              <input
                v-model="lastName"
                v-validate="'required'"
                type="text"
                name="check_last"
                :data-vv-as="$t('Bao.last_name')"
                :placeholder="$t('Bao.name_content')"
                :required="true"
                autocomplete="off"
              >
              <div v-if="errors.has('check_last')" class="help-block">
                {{ $t("Bao.last_name_error") }}
              </div>
            </div>
            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('check_first') }">
              <label>
                {{ $t('Bao.first_name') }}
              </label>
              <input
                v-model="firstName"
                v-validate="'required'"
                type="text"
                name="check_first"
                :data-vv-as="$t('Bao.first_name')"
                :placeholder="$t('Bao.name_content')"
                :required="true"
                autocomplete="off"
              >
              <div v-if="errors.has('check_first')" class="help-block">
                {{ $t("Bao.first_name_error") }}
              </div>
            </div>
            <div class="form-input-1 form-dorp-down-1" :class="{ 'form-input-error-1': errors.has('check_birth') }">
              <label for="">
                {{ $t("Bao.birthday") }}
              </label>
              <input
                v-model="postForm.birthday"
                v-validate="'required'"
                class="modal_register_ipt bg-white border-0"
                type="date"
                name="check_birth"
                :max="maxDate"
                placeholder="Date of birth"
                autocomplete="off"
              >
              <div v-if="errors.has('check_birth')" class="help-block">
                {{ $t("Bao.birthday_error") }}
              </div>
            </div>

            <div class="form-agree">
              <div class="form-checkbox">
                <label class="control">
                  <input v-model="agree" type="checkbox" @click="agree_error = false">
                  <div class="checkbox-indicator" />
                  <span class="register-agree-text">{{ $t("Bao.i_read_and_agree") }}《<span to="/page/privacy" @click="goMemberTerms()">{{ $t("Bao.member_terms") }}</span>》</span>

                </label>
              </div>
              <div>
                <div v-show="agree_error" class="help-block">
                  {{ $t("Bao.have_to_agree_member_terms") }}
                </div>
              </div>
              <div class="form-button form-ft">
                <button class="button-style-7" type="button" :disabled="isButtonDisabled" @click="getVerificationPop">
                  <span>{{ $t("Bao.sign_up_now") }}</span>
                  <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
                </button>
              </div>
              <div class="form-text">
                {{ $t("Bao.account_check") }}

                <a @click="navigateToLogin">
                  {{ $t("Bao.login") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登入/註冊-手機版 -->
    <div class="mobile-login">
      <div class="content">
        <i class="login-logo">
          <img :src="$store.state.brand.brandImage.register_login_above_img[0].image" alt="">
        </i>
        <div class="form-wrap">
          <h4 class="register-title font-w-b text-align-L magin-top-20">
            <span class="highlight-dark-red">{{ $t("Bao.create_account") }}</span>{{ $t("Bao.create") }}
          </h4>
          <h5 class="register-subtitle">
            {{ $t("Bao.contact_info") }}
          </h5>
          <hr class="separator-line">
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('username') }">
            <label for="username">
              {{ $t("Bao.username") }}
            </label>
            <input
              v-model="postForm.username"
              v-validate="'required'"
              class="modal_register_ipt bg-white border-0"
              type="text"
              :placeholder="$t('Bao.member_username_limit')"
              name="username"
              :data-vv-as="$t('Bao.username')"
              autocomplete="off"
              @input="usercheck"
            >
            <div v-if="usernameError === $t('Bao.username_available')" class="account_good">
              {{ usernameError }}
            </div>
            <div v-else-if="usernameError" class="help-block">
              {{ usernameError }}
            </div>
            <div v-else-if="errors.has('username')" class="help-block">
              {{ $t("Bao.user_name_error") }}
            </div>
          </div>
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('newPassword') }">
            <label>
              {{ $t("Bao.password") }}
            </label>
            <input
              ref="newPassword"
              v-model="postForm.newPassword"
              v-validate="'required'"
              class="modal_register_ipt bg-white border-0"
              :placeholder="$t('Bao.password_notice')"
              type="password"
              name="newPassword"
              :data-vv-as="$t('Bao.newPassword')"
              autocomplete="new-password"
              @input="pwdCheck"
            >
            <div v-if="pwdError" class="help-block">
              {{ pwdError }}
            </div>
            <div v-if="errors.has('newPassword')" class="help-block">
              {{ $t("Bao.new_password_error") }}
            </div>
          </div>

          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('confirmPassword') }">
            <label for="passwordz">
              {{ $t("Bao.confirmPassword") }}
            </label>
            <input
              v-model="postForm.confirmPassword"
              v-validate="'required|confirmed:newPassword'"
              class="modal_register_ipt bg-white border-0"
              type="password"
              name="confirmPassword"
              :placeholder="$t('Bao.confirm_pass')"
              :data-vv-as="$t('Bao.confirmPassword')"
              autocomplete="off"
            >
            <div v-if="errors.has('confirmPassword')" class="help-block">
              {{ $t("Bao.confirm_password_error") }}
            </div>
          </div>

          <div v-if="$store.state.brand.permissionInfo.email_need_verify" class="form-input-1" :class="{ 'form-input-error-1': errors.has('email') }">
            <label for="">
              {{ $t("Bao.e-mail") }}
            </label>
            <input
              v-model="postForm.email"
              v-validate="'required'"
              class="modal_register_ipt bg-white border-0"
              type="email"
              name="email"
              :placeholder="$t('Bao.e-mail')"
              autocomplete="off"
            >
            <div v-if="errors.has('email')" class="help-block">
              {{ $t("Bao.email_error") }}
            </div>
          </div>

          <div v-if="$store.state.brand.permissionInfo.register_need_phone" class="form-input-1 form-county-code-1" :class="{ 'form-input-error-1': errors.has('phone') }">
            <label for="">
              {{ $t("Bao.phone") }}
            </label>
            <div class="form-select-1" :class="{ 'active': isFlagShow }" @click="toggleFlagShow">
              <div class="form-select-value">
                <img :src="$getThemeImagePath('japan.png')" alt="">
              </div>
            </div>
            <input
              v-model="postForm.phone"
              v-validate="'required'"
              type="text"
              name="phone"
              :data-vv-as="$t('Bao.phone')"
              :placeholder="$t('Bao.phone_require')"
              :required="true"
              autocomplete="off"
              @input="phonecheck"
            >
            <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
              {{ phoneError }}
            </div>
            <div v-else-if="phoneError" class="help-block">
              {{ phoneError }}
            </div>
          </div>

          <h5 class="register-subtitle">
            {{ $t("Bao.personal_info") }}
          </h5>
          <hr class="separator-line">
          <div class="form-input-1 form-dorp-down-1" :class="{ 'form-input-error-1': errors.has('romanizationOfLastName') }">
            <label>
              {{ $t('Bao.romanization_of_last_name') }}
            </label>
            <input
              v-model="romanizationOfLastName"
              v-validate="'required'"
              type="text"
              name="romanizationOfLastName"
              :data-vv-as="$t('Bao.romanization_of_last_name')"
              :required="true"
              autocomplete="off"
            >
            <div v-if="errors.has('romanizationOfLastName')" class="help-block">
              {{ $t("Bao.romanization_of_last_name_error") }}
            </div>
          </div>
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('romanizationOfFirstName') }">
            <label>
              {{ $t('Bao.romanization_of_first_name') }}
            </label>
            <input
              v-model="romanizationOfFirstName"
              v-validate="'required'"
              type="text"
              name="romanizationOfFirstName"
              :data-vv-as="$t('Bao.romanization_of_first_name')"
              :required="true"
              autocomplete="off"
            >
            <div v-if="errors.has('romanizationOfFirstName')" class="help-block">
              {{ $t("Bao.romanization_of_first_name_error") }}
            </div>
          </div>
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('last_name') }">
            <label>
              {{ $t('Bao.last_name') }}
            </label>
            <input
              v-model="lastName"
              v-validate="'required'"
              type="text"
              name="last_name"
              :data-vv-as="$t('Bao.last_name')"
              :placeholder="$t('Bao.name_content')"
              :required="true"
              autocomplete="off"
            >
            <div v-if="errors.has('last_name')" class="help-block">
              {{ $t("Bao.last_name_error") }}
            </div>
          </div>
          <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('first_name') }">
            <label>
              {{ $t('Bao.first_name') }}
            </label>
            <input
              v-model="firstName"
              v-validate="'required'"
              type="text"
              name="first_name"
              :data-vv-as="$t('Bao.first_name')"
              :placeholder="$t('Bao.name_content')"
              :required="true"
              autocomplete="off"
            >
            <div v-if="errors.has('first_name')" class="help-block">
              {{ $t("Bao.first_name_error") }}
            </div>
          </div>
          <div class="form-input-1 form-dorp-down-1" :class="{ 'form-input-error-1': errors.has('birthday') }">
            <label for="">
              {{ $t("Bao.birthday") }}
            </label>
            <input
              v-model="postForm.birthday"
              v-validate="'required'"
              class="modal_register_ipt bg-white border-0"
              type="date"
              name="birthday"
              :max="maxDate"
              placeholder="Date of birth"
              autocomplete="off"
            >
            <div v-if="errors.has('birthday')" class="help-block">
              {{ $t("Bao.birthday_error") }}
            </div>
          </div>

          <div class="form-agree">
            <div class="form-checkbox">
              <label class="control">
                <input v-model="agree" type="checkbox" @click="agree_error = false">
                <div class="checkbox-indicator" />
                <span>{{ $t("Bao.i_read_and_agree") }}《<span to="/page/privacy" @click="goMemberTerms()">{{ $t("Bao.member_terms") }}</span>》</span>
              </label>
            </div>
            <div>
              <div v-show="agree_error" class="help-block">
                {{ $t("Bao.have_to_agree_member_terms") }}
              </div>
            </div>
            <div class="form-button form-ft">
              <button class="button-style-7" type="button" :disabled="isButtonDisabled" @click="getVerificationPop">
                <span>{{ $t("Bao.sign_up_now") }}</span>
                <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
              </button>
            </div>
            <div class="form-text">
              {{ $t("Bao.account_check") }}

              <a @click="navigateToLogin">
                {{ $t("Bao.login") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--註冊成功-->
    <div v-if="isRegisterSuccess" class="popup-wrap" :class="{ active: isRegisterSuccess }">
      <div class="popup-box">
        <div class="popup-success">
          <i><img :src="$getThemeImagePath('icon-register-success.png')" alt=""></i>
          <h3>{{ $t("Bao.congratulations") }}</h3>
          <h5>{{ $t("Bao.complete_register") }}</h5>
          <button class="button-style-5" @click="goPage">
            <span>{{ $t("Bao.enter") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- email 驗證彈窗 -->
    <div v-if="$store.state.brand.permissionInfo.email_need_verify || $store.state.brand.permissionInfo.register_need_phone && limitVerify" class="popup-wrap popup-register-email" :class="{active:limitVerify}">
      <div class="popup-box">
        <a class="popup-close" href="javascript:;" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup">
          <div class="inner">
            <p class="h4">
              <span v-if="$store.state.brand.permissionInfo.email_need_verify">
                {{ $t("Bao.verify_email") }}
              </span>
              <span v-if="$store.state.brand.permissionInfo.register_need_phone">
                {{ $t("Bao.verify_phone") }}
              </span>
            </p>
            <p class="h5">
              <span v-if="$store.state.brand.permissionInfo.email_need_verify">
                {{ $t("Bao.verify_email_code") }}
              </span>
              <span v-if="$store.state.brand.permissionInfo.register_need_phone">
                {{ $t("Bao.verify_phone_code") }}
              </span>
            </p>
            <div v-if="$store.state.brand.permissionInfo.email_need_verify" class="verify-input">
              <input
                v-model="postForm.emailValidateCode"
                class="modal_register_ipt bg-white border-0"
                type="text"
                name="emailValidateCode"
                autocomplete="off"
              >
              <button class="button-style-7" :disabled="isHandleButtonDisabled" @click="handleRegistration">
                <span>{{ $t("Bao.verify_register") }}</span>
              </button>
            </div>
            <div v-if="$store.state.brand.permissionInfo.register_need_phone" class="verify-input">
              <input
                v-model="postForm.validateCode"
                class="modal_register_ipt bg-white border-0"
                type="text"
                name="phoneValidateCode"
                autocomplete="off"
              >
              <button class="button-style-7" :disabled="isPhoneButtonDisabled" @click="handleRegistration">
                <span>{{ $t("Bao.verify_register") }}</span>
              </button>
            </div>
            <p class="email-notice">
              <i><img :src="$getThemeImagePath('icon-detail.png')" alt=""></i>{{ $t("Bao.email_notice_4") }}
              <span v-if="$store.state.brand.permissionInfo.email_need_verify">{{ $t("Bao.email_notice_5") }}</span>
              <span v-if="$store.state.brand.permissionInfo.register_need_phone">{{ $t("Bao.phone_notice_5") }}</span>
            </p>
            <p>
              {{ $t("Bao.email_notice_1") }}
              <br>
              <span v-if="$store.state.brand.permissionInfo.email_need_verify">
                {{ $t("Bao.email_notice_2") }}
              </span>
              <br>
              <span v-if="$store.state.brand.permissionInfo.email_need_verify">
                {{ $t("Bao.email_notice_3") }}
              </span>
              <span v-if="$store.state.brand.permissionInfo.register_need_phone">
                {{ $t("Bao.phone_notice_3") }}
              </span>
            </p>
            <div class="verify-button">
              <button class="button-style-15" :disabled="timerCount" @click="getVerificationPop">
                <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                <span>{{ timerCount ? '(' + limitSecond + 's)' : $t('Bao.get_verification_code') }}</span>
              </button>
              <button class="button-style-15" @click="changeEmail">
                <span v-if="$store.state.brand.permissionInfo.email_need_verify">
                  {{ $t("Bao.email_change") }}
                </span>
                <span v-if="$store.state.brand.permissionInfo.register_need_phone">
                  {{ $t("Bao.phone_change") }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <success-register />
  </div>
</template>

<script>
import { getPhoneCode, getEmailCode, register, usernameCheck, phoneCheck } from '@/api/user'
import { sendRegisterEvent } from '@/utils/pixel'
import { showNotice } from '@/utils/tool'
import { login as localLogin } from '@/utils/user'
import { validatePassword } from '@/utils/validate'
// import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import SuccessRegister from '@/components/modal/successRegister.vue'

export default {
  components: {
    SuccessRegister
  },
  mixins: [themeMixin],
  data() {
    const postForm = {
      username: null,
      romanization: null, // 羅馬拼音
      name: null, // 漢字拼音
      newPassword: null,
      confirmPassword: null,
      email: null,
      emailValidateCode: null,
      validateCode: null,
      birthday: null,
      phone: null,
      promotion_code: null,
      track_code: null,
      group: null
    }
    return {
      actionLoading: false,
      postForm,
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      lastName: '',
      firstName: '',
      limitSecond: 180,
      timerCount: true,
      limitVerify: false,
      agree: false,
      agree_error: false,
      isFlagShow: false,
      isRegisterSuccess: false,
      previousPhone: '',
      usernameError: '',
      phoneError: '',
      isNameValid: true,
      isPhoneValid: false,
      pwdError: ''
    }
  },
  computed: {
    // ...mapGetters(['']),
    langImagePostfix: function() {
      const lang = this.$store.getters.language
      if (lang === 'zh' || lang === 'tw') {
        return 'zh'
      } else if (lang === 'vn') {
        return 'vn'
      } else {
        return 'en'
      }
    },
    maxDate() {
      const currentDate = new Date()
      const year = currentDate.getFullYear().toString()
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0') // getMonth() is zero-based
      const day = currentDate.getDate().toString().padStart(2, '0')
      const maxDate = `${year}-${month}-${day}`
      return maxDate
    },
    combinedRomanization() {
      return this.romanizationOfLastName && this.romanizationOfFirstName
        ? this.romanizationOfLastName + ',' + this.romanizationOfFirstName
        : null
    },
    combinedName() {
      return this.lastName && this.firstName
        ? this.lastName + ',' + this.firstName
        : null
    },
    isButtonDisabled() {
      const hasErrors = this.errors.any()
      /* eslint-disable no-unused-vars */
      const { emailValidateCode, validateCode, promotion_code, email, track_code, group, ...formToCheck } = this.postForm
      const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
      return hasErrors || !this.agree || !this.isNameValid || !this.isPhoneValid || !this.isPwdValid || hasEmptyFields
    },
    isHandleButtonDisabled() {
      return this.postForm.emailValidateCode === null || this.postForm.emailValidateCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.postForm.validateCode === null || this.postForm.validateCode.trim() === ''
    }
  },
  watch: {
    combinedRomanization(newValue) {
      this.postForm.romanization = newValue
    },
    combinedName(newValue) {
      this.postForm.name = newValue
    }
  },
  created() {
    let url = (window.location.href || document.location.href).replace('&amp;', '&')
    url = url.replace('&amp%3B', '&')
    if (this.$store.getters.inviteCode !== null) {
      this.postForm.promotion_code = this.$store.getters.inviteCode
      this.isCodeReadOnly = true
    }

    if (this.$store.getters.group !== null) {
      this.postForm.group = this.$store.getters.group
    }

    const trackCode = new URL(url).searchParams.get('trackCode')
    if (trackCode) {
      this.$store.commit('SET_TRACK_CODE', trackCode)
      this.postForm.track_code = trackCode
    }
    this.debounceCheckUsername = this.debounce(this.usernameApiCall, 700)
    this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
  },
  methods: {
    usernameApiCall() {
      if (this.postForm.username && this.postForm.username.trim() !== '') {
        usernameCheck({ username: this.postForm.username }).then(res => {
          if (res.status === 200) {
            // 检查是否全数字
            const isAllDigits = /^\d+$/.test(this.postForm.username)
            // 检查是否全英文（仅限字母）
            const isAllLetters = /^[A-Za-z]+$/.test(this.postForm.username)
            // 检查是否包含标点符号
            const hasPunctuation = /[^\w\s]/.test(this.postForm.username)
            // 含大寫英文
            const hasUpperCase = /[A-Z]/.test(this.postForm.username)

            if (isAllDigits || isAllLetters || hasPunctuation || hasUpperCase) {
              this.isNameValid = false
              this.usernameError = this.$t('Bao.username_format_error')
            } else {
              this.usernameError = this.$t('Bao.username_available')
              this.isNameValid = true
            }
          } else if (res.status === 201) {
            if (this.postForm.username.length < 8) {
              this.usernameError = this.$t('Bao.username_format_error')
            } else {
              this.usernameError = this.$t('Bao.username_duplicate')
            }
            this.isNameValid = false
          }
        }).catch(err => {
          console.log(err)
          this.isNameValid = false
        })
      }
    },
    phoneApiCall() {
      const formattedPhone = `+81${this.postForm.phone.substring(1)}`
      if (this.postForm.phone && this.postForm.phone.trim() !== '') {
        phoneCheck({ phone: formattedPhone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.postForm.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    pwdCheck() {
      const { valid, error } = validatePassword(this.postForm.newPassword, this.$t.bind(this))
      this.isPwdValid = valid
      this.pwdError = error
    },
    usercheck() {
      if (!this.postForm.username) {
        this.usernameError = this.$t('Bao.user_name_error')
        this.isNameValid = false
      }
      if (this.postForm.username) {
        this.debounceCheckUsername()
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    goMemberTerms() {
      this.agree_error = false
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.$router.push('/page/terms')
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    handleRegistration() {
      this.executeRegistration()
    },
    closeVerify() {
      this.limitVerify = false
      this.resetPostForm()
    },
    toggleFlagShow() {
      this.isFlagShow = !this.isFlagShow
    },
    formatPhoneNumber(input) {
      if (process.env.VUE_APP_CURRENCY === 'JPY') {
        let str = '' + input
        if (/^\+81 \d{2}-\d{4}-\d{4}$/.test(str)) {
        // If it matches, return the original input as it is
          return str
        }
        // If the phone number starts with a '0', remove the '0'
        if (str.startsWith('0')) {
          str = str.substring(1)
        }
        // Remove any existing non-digit characters from the string
        str = str.replace(/\D/g, '')
        // Add the country code and hyphens
        return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
      } else {
        return input
      }
    },
    navigateToLogin() {
      this.$store.commit('SET_PROMOTION', true)
      this.$router.push('/')
      this.$validator.errors.items = []
      this.agree_error = false
    },
    openEmailVerify() {
      getEmailCode({ email: this.postForm.email }).then(response => {
        showNotice(response.data.msg)
        this.timerCount = true
        this.limitVerify = true
        this.countDown()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    changeEmail() {
      this.limitVerify = false
    },
    openPhoneVerify() {
      const phoneToUse = this.postForm.phone
      const formattedPhone = `+81${phoneToUse.substring(1)}`
      getPhoneCode({ phone: formattedPhone }).then(response => {
        showNotice(response.data.msg)
        this.$store.commit('SET_REGISTER_OPEN', false)
        this.timerCount = true
        this.limitVerify = true
        this.countDown()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    getVerificationPop() {
      if (this.$store.state.brand.permissionInfo.email_need_verify) {
        this.openEmailVerify()
        return
      } else {
        this.openPhoneVerify()
      }
    },
    executeRegistration() {
      this.actionLoading = true
      this.postForm.password = this.postForm.newPassword
      this.postForm.phone = this.formatPhoneNumber(this.postForm.phone)
      register(this.postForm).then(response => {
        if (this.isTheme('theme_gold') && process.env.VUE_APP_ENV === 'production') {
          sendRegisterEvent()
        }
        showNotice(response.data.msg, () => {
          localLogin(response.data.data, null)
          this.resetPostForm()
          this.limitVerify = false
          this.isRegisterSuccess = true
        })
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    goPage() {
      this.isRegisterSuccess = false
      this.$store.commit('SET_REGISTER_SUCCESS', true)
    },
    resetPostForm() {
      this.$validator.errors.items = []
      this.postForm = {
        username: null,
        romanization: null,
        name: null,
        newPassword: null,
        confirmPassword: null,
        email: null,
        emailValidateCode: null,
        birthday: null,
        phone: null,
        promotion_code: null,
        track_code: null,
        group: null
      }
      this.romanizationOfLastName = ''
      this.romanizationOfFirstName = ''
      this.lastName = ''
      this.firstName = ''
      this.usernameError = ''
      this.phoneError = ''
      this.pwdError = ''
    }
  }
}
</script>

<style scoped>
  .form-agree .help-block{
    text-align: center;
  }

  .form-button button:disabled.button-style-7{
    background: #b9b9b9;
  }
</style>
